import dayjs from 'dayjs';

export const triggerCSVExport = (fileName: string, rows: string[][]): void => {
  const csvContent = rows.map((row) => row.map(escapeValueForCsv).join(',')).join('\n');

  const formattedFileName = formatCsvFileName(fileName);

  const link = document.createElement('a');

  const url = URL.createObjectURL(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }));

  link.href = url;
  link.download = formattedFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

function formatCsvFileName(baseFileName: string) {
  const timestamp = dayjs().format('YYYY-MM-DD_HHmmss');

  return `${baseFileName}_${timestamp}.csv`;
}

/**
 * Escapes CSV special characters such as quotes and commas.
 * encloses the string in quotes if it contains a special character.
 */
function escapeValueForCsv(value?: string) {
  const escapedValue = (value?.toString() ?? '').replace(/"/g, '""');

  return /("|,|\n)/.test(escapedValue) ? `"${escapedValue}"` : escapedValue;
}
